import * as React from 'react';
import { useStore } from '@base-ui/utils/store';
import { useAdapterContext } from '@mui/x-scheduler-headless/use-adapter-context';
import { useSchedulerStoreContext } from '@mui/x-scheduler-headless/use-scheduler-store-context';
import { schedulerPreferenceSelectors } from '@mui/x-scheduler-headless/scheduler-selectors';
import { formatHourAndMinutes } from "../utils/date-utils.mjs";
export function useFormatTime() {
  // Context hooks
  const adapter = useAdapterContext();
  const store = useSchedulerStoreContext();

  // Selector hooks
  const ampm = useStore(store, schedulerPreferenceSelectors.ampm);
  return React.useCallback(date => {
    return formatHourAndMinutes(date, adapter, ampm);
  }, [adapter, ampm]);
}